import script from "./goodsSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsSearch.vue?vue&type=script&setup=true&lang=js"

import "./goodsSearch.vue?vue&type=style&index=0&id=787957dc&lang=less"

const __exports__ = script;

export default __exports__